import { GB, MY } from '@Utils/constants';
import { getContentCountryCode } from '../user-flow/individual/revampedUserFlow/utils/Util';

export const Screens = {
  identityCheck: 'identity_check',
  jumio: 'jumio',
  loading: 'loading',
  ekycServiceDown: 'ekyc_service_down',
  success: 'success',
  pending: 'pending'
};

export const EKYC_RFI_EKYC_SERVICE_DOWN = {
  heading: 'eKYC service down',
  description:
    'We apologize for the inconvenience, but our eKYC services are down currently. Please check back later.',
  goToHomeCTA: 'Go to Home'
};

export const UNDER_REVIEW_PAGE = {
  heading: 'Reviewing your details',
  description:
    'Our team is reviewing your account details. We’ll get back to you within 1 business day.',
  goToHomeCTA: 'Go to Home'
};

export const LOADING_SCREEN = {
  heading: 'Please wait while we fetch your details',
  description: 'Don’t close this window, you will be redirected shortly.',
  loadingTime: 7000
};

export const EKYC_RFI_SUCCESS_PAGE = {
  heading: 'You’re all set!',
  description: 'Start sending money to your friends, family or anyone.',
  sendMoneyCTA: 'Send money',
  goToHomeCTA: 'Go to Home'
};

export const IDENTITY_PAGE = {
  heading: 'Identity check',
  description: `Grab your ID documents and find the best lighting to click a picture. 
    For a smooth experience, make sure you follow the instructions carefully.`,
  buttonCTA: 'Scan ID document',
  provideDocsMsg: 'You will be asked to provide a photo of the following:',
  docList: {
    MY: {
      checkPoint: {
        note1: 'Your original MyPR or MyKAD',
        note2: 'Your selfie',
        note1ForNonMy: 'Your original Passport',
        note1ForOther: 'Your original Passport'
      }
    },
    GB: {
      checkPoint: {
        note1: `Your original passport or residence permit and `,
        note2: 'Your selfie',
        note3: 'Your original passport or residence permit and ',
        note1ForOther: `Your original passport or national ID or residence permit and`
      }
    },
    EU: {
      checkPoint: {
        note1: 'Your original passport or residence permit and ',
        note2: 'Your selfie',
        note3: 'Your original passport or residence permit and ',
        note1ForOther: 'Your original passport or national ID or residence permit and'
      }
    }
  }
};

export const JUMIO_RFI_PAGE = {
  myNational: 'Upload a photo copy of your Malaysian ID Card(MYKAD/MYPR)',
  nonMyNational: 'Upload a photo copy of your Passport'
};

export const isJumioApplicable = (countryCode: string) => {
  const formattedCountryCode = getContentCountryCode(countryCode);
  return ['EU', GB, MY].includes(formattedCountryCode);
};
